import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/icon/amway-cc-logo-b.svg'
import _imports_1 from '@/assets/icon/icon-team.svg'
import _imports_2 from '@/assets/icon/icon-reward.svg'
import _imports_3 from '@/assets/icon/icon-register-w.svg'
import _imports_4 from '@/assets/icon/icon-people.svg'
import _imports_5 from '@/assets/icon/icon-back-to.svg'
import _imports_6 from '@/assets/icon/amway-cc-logo-m.svg'
import _imports_7 from '@/assets/images/people-01.png'
import _imports_8 from '@/assets/images/board/confetti.svg'
import _imports_9 from '@/assets/images/board/confetti-m.svg'
import _imports_10 from '@/assets/images/board/red-ribbon.svg'
import _imports_11 from '@/assets/images/board/final-1to10-reward.svg'
import _imports_12 from '@/assets/images/board/final-1to10-reward-m.svg'
import _imports_13 from '@/assets/images/board/firework-team.svg'
import _imports_14 from '@/assets/images/board/firework-team-m.svg'
import _imports_15 from '@/assets/images/board/coin-star.svg'
import _imports_16 from '@/assets/images/board/final-11to70-reward.svg'
import _imports_17 from '@/assets/images/board/final-no-reward.svg'
import _imports_18 from '@/assets/images/board/final-no-reward-bg.svg'
import _imports_19 from '@/assets/images/board/team-score-bg.svg'
import _imports_20 from '@/assets/images/board/team-score-bg-m.svg'
import _imports_21 from '@/assets/images/board/reward-w1-r1.svg'
import _imports_22 from '@/assets/images/board/reward-w1-r21.svg'
import _imports_23 from '@/assets/images/board/reward-w1-r41.svg'
import _imports_24 from '@/assets/images/board/reward-w6-r1.svg'
import _imports_25 from '@/assets/images/board/reward-w6-r21.svg'
import _imports_26 from '@/assets/images/board/reward-w6-r41.svg'
import _imports_27 from '@/assets/images/board/bonus-flag.svg'
import _imports_28 from '@/assets/icon/amway-logo.svg'
import _imports_29 from '@/assets/icon/icon-phone.svg'


const _hoisted_1 = { class: "team-score" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "header-area desktop" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Amway Creator Challenge"
}, null, -1)
const _hoisted_5 = { class: "header-right" }
const _hoisted_6 = { class: "header-menu" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("คะแนนทีมของคุณ")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("ผลการแข่งขันรายสัปดาห์")
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode("ประกาศผลรางวัลชนะเลิศ")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }),
  /*#__PURE__*/_createTextVNode("รายละเอียดกิจกรรม")
], -1)
const _hoisted_14 = { class: "profile-area" }
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  class: "profile-info",
  id: "profile-info"
}
const _hoisted_17 = { class: "profile-info-area" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1)
const _hoisted_19 = { class: "profile-info-name" }
const _hoisted_20 = { class: "profile-info-id" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.amway.co.th",
  target: "_blank",
  class: "link-red"
}, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_5 }),
  /*#__PURE__*/_createTextVNode("กลับไปยังเว็บไซต์หลัก ")
], -1)
const _hoisted_22 = { class: "header-area mobile" }
const _hoisted_23 = { class: "header-logo-area" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: "Amway Creator Challenge"
}, null, -1)
const _hoisted_25 = {
  class: "profile-area",
  id: "profile-area-m"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("img", { src: _imports_7 }, null, -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = {
  class: "profile-info",
  id: "profile-info-m"
}
const _hoisted_29 = { class: "profile-info-area" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1)
const _hoisted_31 = { class: "profile-info-name" }
const _hoisted_32 = { class: "profile-info-id" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.amway.co.th",
  class: "link-red"
}, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_5 }),
  /*#__PURE__*/_createTextVNode("กลับไปยังเว็บไซต์หลัก ")
], -1)
const _hoisted_34 = {
  class: "sub-menu",
  id: "sub-menu"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createTextVNode("คะแนนทีมของคุณ ")
const _hoisted_37 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_38 = /*#__PURE__*/_createTextVNode("ผลการแข่งขันรายสัปดาห์ ")
const _hoisted_39 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_40 = /*#__PURE__*/_createTextVNode("ประกาศผลรางวัลชนะเลิศ ")
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }),
  /*#__PURE__*/_createTextVNode("รายละเอียดกิจกรรม ")
], -1)
const _hoisted_42 = { class: "team-score-board-content" }
const _hoisted_43 = {
  key: 0,
  src: _imports_8,
  class: "confetti-team desktop"
}
const _hoisted_44 = {
  key: 1,
  src: _imports_9,
  class: "confetti-team mobile"
}
const _hoisted_45 = {
  key: 2,
  class: "container"
}
const _hoisted_46 = { class: "title-area" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "title-page-r" }, "รางวัลชนะเลิศ", -1)
const _hoisted_48 = { class: "ribbon-area final" }
const _hoisted_49 = { class: "ribbon-text-area" }
const _hoisted_50 = { class: "rta-text" }
const _hoisted_51 = { class: "rta-name" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("img", { src: _imports_10 }, null, -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_11,
  class: "reward-image-d"
}, null, -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_12,
  class: "reward-image-m final"
}, null, -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_13,
  class: "firework-team desktop"
}, null, -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_14,
  class: "firework-team mobile"
}, null, -1)
const _hoisted_57 = { class: "total-team-score" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("img", { src: _imports_15 }, null, -1)
const _hoisted_59 = /*#__PURE__*/_createTextVNode("คะแนนรวม ")
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "reward-text" }, [
  /*#__PURE__*/_createTextVNode(" รับทริปไปท่องเที่ยวญี่ปุ่น เกียวโต โอซาก้า "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("พร้อมกับกูรูด้านการถ่ายภาพ สร้างคอนเทนต์แบบครีเอเตอร์โปร"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "มูลค่า 350,000 บาท/ทีม")
], -1)
const _hoisted_61 = {
  key: 3,
  class: "container"
}
const _hoisted_62 = { class: "title-area" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "title-page-r" }, "รางวัลชมเชย", -1)
const _hoisted_64 = { class: "ribbon-area final" }
const _hoisted_65 = { class: "ribbon-text-area" }
const _hoisted_66 = { class: "rta-text" }
const _hoisted_67 = { class: "rta-name" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("img", { src: _imports_10 }, null, -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_16,
  class: "reward-image-d"
}, null, -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_16,
  class: "reward-image-m final"
}, null, -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_13,
  class: "firework-team desktop"
}, null, -1)
const _hoisted_72 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_14,
  class: "firework-team mobile"
}, null, -1)
const _hoisted_73 = { class: "total-team-score" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("img", { src: _imports_15 }, null, -1)
const _hoisted_75 = /*#__PURE__*/_createTextVNode("คะแนนรวม ")
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", { class: "reward-text" }, [
  /*#__PURE__*/_createTextVNode(" รับกิ๊ฟท์เซตกล้องโพลารอยด์ครีเอเตอร์สุดเก๋ ท่านละ 1 ชุด"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "มูลค่า 1,600 บาท/รางวัล รวม 60 รางวัล")
], -1)
const _hoisted_77 = {
  key: 4,
  class: "container"
}
const _hoisted_78 = { class: "title-area" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("div", { class: "title-page-r" }, "ผลการแข่งขันรายสัปดาห์", -1)
const _hoisted_80 = { class: "ribbon-area final" }
const _hoisted_81 = { class: "ribbon-text-area" }
const _hoisted_82 = { class: "rta-text" }
const _hoisted_83 = { class: "rta-name" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("img", { src: _imports_10 }, null, -1)
const _hoisted_85 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_17,
  class: "reward-image-d"
}, null, -1)
const _hoisted_86 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_17,
  class: "reward-image-m final"
}, null, -1)
const _hoisted_87 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_18,
  class: "reward-team desktop"
}, null, -1)
const _hoisted_88 = { class: "total-team-score" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("img", { src: _imports_15 }, null, -1)
const _hoisted_90 = /*#__PURE__*/_createTextVNode("คะแนนรวม ")
const _hoisted_91 = /*#__PURE__*/_createElementVNode("div", { class: "reward-text" }, [
  /*#__PURE__*/_createTextVNode(" ทีมของคุณไม่ได้รับรางวัลในกิจกรรมครั้งนี้ "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("สู้กันใหม่ในกิจกรรมถัดไป ")
], -1)
const _hoisted_92 = {
  key: 5,
  class: "content-section"
}
const _hoisted_93 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_19,
  class: "content-team-bg"
}, null, -1)
const _hoisted_94 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_20,
  class: "content-team-bg-m"
}, null, -1)
const _hoisted_95 = { class: "container" }
const _hoisted_96 = { class: "tt-head-left" }
const _hoisted_97 = { class: "tt-week" }
const _hoisted_98 = { class: "tt-date" }
const _hoisted_99 = { class: "tt-head-right" }
const _hoisted_100 = { class: "tt-point-area" }
const _hoisted_101 = { class: "tt-point" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("div", { class: "btn-expand" }, null, -1)
const _hoisted_103 = { class: "tt-body" }
const _hoisted_104 = { class: "tt-row" }
const _hoisted_105 = { class: "tt-col" }
const _hoisted_106 = { class: "team-reward-detail" }
const _hoisted_107 = {
  key: 0,
  src: _imports_21
}
const _hoisted_108 = {
  key: 1,
  src: _imports_22
}
const _hoisted_109 = {
  key: 2,
  src: _imports_23
}
const _hoisted_110 = {
  key: 3,
  src: _imports_24
}
const _hoisted_111 = {
  key: 4,
  src: _imports_25
}
const _hoisted_112 = {
  key: 5,
  src: _imports_26
}
const _hoisted_113 = {
  key: 6,
  class: ""
}
const _hoisted_114 = /*#__PURE__*/_createElementVNode("div", { class: "trd-name" }, "นิวทริไลท์ ออลแพลนท์ โปรตีน", -1)
const _hoisted_115 = /*#__PURE__*/_createElementVNode("div", {
  class: "trd-value",
  style: {"text-align":"center"}
}, "มูลค่า 1,100 บาท", -1)
const _hoisted_116 = [
  _hoisted_114,
  _hoisted_115
]
const _hoisted_117 = {
  key: 7,
  class: ""
}
const _hoisted_118 = /*#__PURE__*/_createElementVNode("div", { class: "trd-name" }, "นิวทริไลท์ น้ำมันปลา", -1)
const _hoisted_119 = /*#__PURE__*/_createElementVNode("div", {
  class: "trd-value",
  style: {"text-align":"center"}
}, "มูลค่า 800 บาท", -1)
const _hoisted_120 = [
  _hoisted_118,
  _hoisted_119
]
const _hoisted_121 = {
  key: 8,
  class: ""
}
const _hoisted_122 = /*#__PURE__*/_createElementVNode("div", { class: "trd-name" }, "นิวทริไลท์ วิตามินบี พลัส", -1)
const _hoisted_123 = /*#__PURE__*/_createElementVNode("div", {
  class: "trd-value",
  style: {"text-align":"center"}
}, "มูลค่า 480 บาท", -1)
const _hoisted_124 = [
  _hoisted_122,
  _hoisted_123
]
const _hoisted_125 = {
  key: 9,
  class: ""
}
const _hoisted_126 = /*#__PURE__*/_createElementVNode("div", { class: "trd-name" }, "นิวทริไลท์ โพรไบโอติก", -1)
const _hoisted_127 = /*#__PURE__*/_createElementVNode("div", {
  class: "trd-value",
  style: {"text-align":"center"}
}, "มูลค่า 1,500 บาท", -1)
const _hoisted_128 = [
  _hoisted_126,
  _hoisted_127
]
const _hoisted_129 = {
  key: 10,
  class: ""
}
const _hoisted_130 = /*#__PURE__*/_createElementVNode("div", { class: "trd-name" }, "นิวทริไลท์ การ์ลิค", -1)
const _hoisted_131 = /*#__PURE__*/_createElementVNode("div", {
  class: "trd-value",
  style: {"text-align":"center"}
}, "มูลค่า 1,088 บาท", -1)
const _hoisted_132 = [
  _hoisted_130,
  _hoisted_131
]
const _hoisted_133 = {
  key: 11,
  class: ""
}
const _hoisted_134 = /*#__PURE__*/_createElementVNode("div", { class: "trd-name" }, "เอ็น บาย นิวทริไลท์ เอ็น* ชา", -1)
const _hoisted_135 = /*#__PURE__*/_createElementVNode("div", {
  class: "trd-value",
  style: {"text-align":"center"}
}, "มูลค่า 540 บาท", -1)
const _hoisted_136 = [
  _hoisted_134,
  _hoisted_135
]
const _hoisted_137 = { class: "team-layer-1" }
const _hoisted_138 = { class: "team-layer-2" }
const _hoisted_139 = { class: "team-layer-3" }
const _hoisted_140 = { class: "team-layer-4" }
const _hoisted_141 = { class: "team-datails" }
const _hoisted_142 = { class: "team-position" }
const _hoisted_143 = { class: "team-name" }
const _hoisted_144 = { style: {"white-space":"pre-line"} }
const _hoisted_145 = {
  key: 0,
  class: "tt-row"
}
const _hoisted_146 = /*#__PURE__*/_createElementVNode("div", { class: "tt-col" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tt-title" }, "สมาชิกที่เป็นนธอ. ใหม่")
], -1)
const _hoisted_147 = { class: "tt-row" }
const _hoisted_148 = /*#__PURE__*/_createElementVNode("div", { class: "tt-col" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tt-title" }, "การเข้าเรียน")
], -1)
const _hoisted_149 = { class: "tt-row" }
const _hoisted_150 = /*#__PURE__*/_createElementVNode("div", { class: "tt-col" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tt-title" }, "การโพสต์คอนเทนต์")
], -1)
const _hoisted_151 = { class: "tt-row" }
const _hoisted_152 = /*#__PURE__*/_createElementVNode("div", { class: "tt-col" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tt-title" }, "การสปอนเซอร์")
], -1)
const _hoisted_153 = { class: "tt-body-m" }
const _hoisted_154 = { class: "team-reward-detail" }
const _hoisted_155 = {
  key: 0,
  src: _imports_21
}
const _hoisted_156 = {
  key: 1,
  src: _imports_22
}
const _hoisted_157 = {
  key: 2,
  src: _imports_23
}
const _hoisted_158 = {
  key: 3,
  src: _imports_24
}
const _hoisted_159 = {
  key: 4,
  src: _imports_25
}
const _hoisted_160 = {
  key: 5,
  src: _imports_26
}
const _hoisted_161 = { class: "trd-detail" }
const _hoisted_162 = {
  key: 0,
  class: ""
}
const _hoisted_163 = /*#__PURE__*/_createElementVNode("div", { class: "trd-name" }, "นิวทริไลท์ ออลแพลนท์ โปรตีน", -1)
const _hoisted_164 = /*#__PURE__*/_createElementVNode("div", {
  class: "trd-value",
  style: {"text-align":"center"}
}, "มูลค่า 1,100 บาท", -1)
const _hoisted_165 = [
  _hoisted_163,
  _hoisted_164
]
const _hoisted_166 = {
  key: 1,
  class: ""
}
const _hoisted_167 = /*#__PURE__*/_createElementVNode("div", { class: "trd-name" }, "นิวทริไลท์ น้ำมันปลา", -1)
const _hoisted_168 = /*#__PURE__*/_createElementVNode("div", {
  class: "trd-value",
  style: {"text-align":"center"}
}, "มูลค่า 800 บาท", -1)
const _hoisted_169 = [
  _hoisted_167,
  _hoisted_168
]
const _hoisted_170 = {
  key: 2,
  class: ""
}
const _hoisted_171 = /*#__PURE__*/_createElementVNode("div", { class: "trd-name" }, "นิวทริไลท์ วิตามินบี พลัส", -1)
const _hoisted_172 = /*#__PURE__*/_createElementVNode("div", {
  class: "trd-value",
  style: {"text-align":"center"}
}, "มูลค่า 480 บาท", -1)
const _hoisted_173 = [
  _hoisted_171,
  _hoisted_172
]
const _hoisted_174 = {
  key: 3,
  class: ""
}
const _hoisted_175 = /*#__PURE__*/_createElementVNode("div", { class: "trd-name" }, "นิวทริไลท์ โพรไบโอติก", -1)
const _hoisted_176 = /*#__PURE__*/_createElementVNode("div", {
  class: "trd-value",
  style: {"text-align":"center"}
}, "มูลค่า 1,500 บาท", -1)
const _hoisted_177 = [
  _hoisted_175,
  _hoisted_176
]
const _hoisted_178 = {
  key: 4,
  class: ""
}
const _hoisted_179 = /*#__PURE__*/_createElementVNode("div", { class: "trd-name" }, "นิวทริไลท์ การ์ลิค", -1)
const _hoisted_180 = /*#__PURE__*/_createElementVNode("div", {
  class: "trd-value",
  style: {"text-align":"center"}
}, "มูลค่า 1,088 บาท", -1)
const _hoisted_181 = [
  _hoisted_179,
  _hoisted_180
]
const _hoisted_182 = {
  key: 5,
  class: ""
}
const _hoisted_183 = /*#__PURE__*/_createElementVNode("div", { class: "trd-name" }, "เอ็น บาย นิวทริไลท์ เอ็น* ชา", -1)
const _hoisted_184 = /*#__PURE__*/_createElementVNode("div", {
  class: "trd-value",
  style: {"text-align":"center"}
}, "มูลค่า 540 บาท", -1)
const _hoisted_185 = [
  _hoisted_183,
  _hoisted_184
]
const _hoisted_186 = { class: "team-detail-area" }
const _hoisted_187 = { class: "team-layer-1" }
const _hoisted_188 = { class: "team-layer-2" }
const _hoisted_189 = { class: "team-layer-3" }
const _hoisted_190 = { class: "team-layer-4" }
const _hoisted_191 = { class: "team-datails" }
const _hoisted_192 = { class: "team-position" }
const _hoisted_193 = { class: "team-name" }
const _hoisted_194 = { class: "team-point-detail" }
const _hoisted_195 = { class: "tt-detail-row" }
const _hoisted_196 = {
  key: 0,
  class: "tt-title"
}
const _hoisted_197 = { class: "tt-detail-row" }
const _hoisted_198 = /*#__PURE__*/_createElementVNode("div", { class: "tt-title" }, "การเข้าเรียน", -1)
const _hoisted_199 = { class: "tt-detail-row" }
const _hoisted_200 = /*#__PURE__*/_createElementVNode("div", { class: "tt-title" }, "การโพสต์คอนเทนต์", -1)
const _hoisted_201 = { class: "tt-detail-row" }
const _hoisted_202 = /*#__PURE__*/_createElementVNode("div", { class: "tt-title" }, "การสปอนเซอร์", -1)
const _hoisted_203 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_27,
  class: "bonus-flag"
}, null, -1)
const _hoisted_204 = { class: "team-table" }
const _hoisted_205 = /*#__PURE__*/_createElementVNode("div", { class: "tt-head-left" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tt-special-point" }, "คะแนนพิเศษ")
], -1)
const _hoisted_206 = { class: "tt-head-right" }
const _hoisted_207 = { class: "tt-point-area" }
const _hoisted_208 = { class: "tt-point" }
const _hoisted_209 = /*#__PURE__*/_createElementVNode("div", { class: "btn-expand" }, null, -1)
const _hoisted_210 = { class: "tt-body" }
const _hoisted_211 = { class: "tt-row" }
const _hoisted_212 = /*#__PURE__*/_createElementVNode("div", { class: "tt-col" }, null, -1)
const _hoisted_213 = { class: "team-layer-1" }
const _hoisted_214 = { class: "team-layer-2" }
const _hoisted_215 = { class: "team-layer-3" }
const _hoisted_216 = { class: "team-layer-4" }
const _hoisted_217 = { class: "team-datails" }
const _hoisted_218 = { class: "team-position" }
const _hoisted_219 = { class: "team-name" }
const _hoisted_220 = { style: {"white-space":"pre-line"} }
const _hoisted_221 = { class: "tt-row" }
const _hoisted_222 = /*#__PURE__*/_createElementVNode("div", { class: "tt-col" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tt-title" }, "เข้ากลุ่ม Facebook")
], -1)
const _hoisted_223 = { class: "tt-row" }
const _hoisted_224 = /*#__PURE__*/_createElementVNode("div", { class: "tt-col" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tt-title" }, "ชุดเริ่มควบคุมน้ำหนักบอดี้คีย์")
], -1)
const _hoisted_225 = { class: "tt-body-m" }
const _hoisted_226 = { class: "team-layer-1" }
const _hoisted_227 = { class: "team-layer-2" }
const _hoisted_228 = { class: "team-layer-3" }
const _hoisted_229 = { class: "team-layer-4" }
const _hoisted_230 = { class: "team-datails" }
const _hoisted_231 = { class: "team-position" }
const _hoisted_232 = { class: "team-name" }
const _hoisted_233 = { style: {"white-space":"pre-line"} }
const _hoisted_234 = { class: "team-point-detail" }
const _hoisted_235 = { class: "tt-detail-row" }
const _hoisted_236 = /*#__PURE__*/_createElementVNode("div", { class: "tt-title" }, "เข้ากลุ่ม Facebook", -1)
const _hoisted_237 = { class: "tt-text" }
const _hoisted_238 = { class: "tt-detail-row" }
const _hoisted_239 = /*#__PURE__*/_createElementVNode("div", { class: "tt-title" }, "ชุดเริ่มควบคุมน้ำหนักบอดี้คีย์", -1)
const _hoisted_240 = { class: "tt-text" }
const _hoisted_241 = /*#__PURE__*/_createStaticVNode("<section class=\"footer\"><div class=\"container\"><div class=\"row mx-0\"><div class=\"footer-logo\"><img src=\"" + _imports_28 + "\" height=\"40px\"></div><div class=\"footer-address\"> บริษัท แอมเวย์ (ประเทศไทย) จำกัด <br>1199/1 ถนนรามคำแหง แขวงหัวหมาก เขตบางกะปิ กรุงเทพ ฯ 10240 </div><div class=\"footer-call\"><div class=\"footer-call-text\">ต้องการความช่วยเหลือ ?</div><div class=\"footer-call-phone\"><img src=\"" + _imports_29 + "\"><a href=\"tel:+0-2725-8000\">0-2725-8000</a></div></div><div class=\"copy-right\">Copyright 2022, Amway (Thailand) Ltd,.</div></div></div></section>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/final_result",
          class: "header-logo"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_router_link, { to: "final_score" }, {
              default: _withCtx(() => [
                _hoisted_7,
                _hoisted_8
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: "leader_board" }, {
              default: _withCtx(() => [
                _hoisted_9,
                _hoisted_10
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: "final_result" }, {
              default: _withCtx(() => [
                _hoisted_11,
                _hoisted_12
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/challenge",
              class: "btn-red",
              style: {"width":"184px"}
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", {
              class: "profile-icon",
              onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.showProfileInfo();})
            }, [
              _createElementVNode("img", {
                src: _ctx.$store.state.userInfo.profile_image ? _ctx.$store.state.userInfo.profile_image : require('@/assets/images/landing/people.svg')
              }, null, 8, _hoisted_15)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$store.state.userInfo.name), 1),
                  _createElementVNode("div", _hoisted_20, "รหัสนักธุรกิจแอมเวย์ " + _toDisplayString(_ctx.$store.state.userInfo.abo_id), 1)
                ])
              ]),
              _hoisted_21
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", {
            class: "ham",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openMenu(this)))
          }),
          _createVNode(_component_router_link, {
            to: "final_result",
            class: "header-logo"
          }, {
            default: _withCtx(() => [
              _hoisted_24
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", {
            class: "profile-icon",
            onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.showProfileInfo();})
          }, _hoisted_27),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$store.state.userInfo.name), 1),
                _createElementVNode("div", _hoisted_32, "รหัสนักธุรกิจแอมเวย์ " + _toDisplayString(_ctx.$store.state.userInfo.abo_id), 1)
              ])
            ]),
            _hoisted_33
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createVNode(_component_router_link, { to: "final_score" }, {
            default: _withCtx(() => [
              _hoisted_35,
              _hoisted_36
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "leader_board" }, {
            default: _withCtx(() => [
              _hoisted_37,
              _hoisted_38
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "final_result" }, {
            default: _withCtx(() => [
              _hoisted_39,
              _hoisted_40
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/challenge",
            class: "btn-red fixed",
            style: {"right":"16px","bottom":"0","width":"calc(100% - 32px)"},
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openMenu()))
          }, {
            default: _withCtx(() => [
              _hoisted_41
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_42, [
      (_ctx.currentRank > 1 && _ctx.currentRank <= 10)
        ? (_openBlock(), _createElementBlock("img", _hoisted_43))
        : _createCommentVNode("", true),
      (_ctx.currentRank > 1 && _ctx.currentRank <= 10)
        ? (_openBlock(), _createElementBlock("img", _hoisted_44))
        : _createCommentVNode("", true),
      (_ctx.currentRank > 1 && _ctx.currentRank <= 10)
        ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _hoisted_47,
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, "อันดับที่ " + _toDisplayString(_ctx.currentRank), 1),
                  _createElementVNode("div", _hoisted_51, "ทีม " + _toDisplayString(_ctx.team.team_name), 1)
                ]),
                _hoisted_52
              ]),
              _hoisted_53,
              _hoisted_54,
              _hoisted_55,
              _hoisted_56,
              _createElementVNode("div", _hoisted_57, [
                _hoisted_58,
                _hoisted_59,
                _createElementVNode("span", null, _toDisplayString(_ctx.team.weeks ? _ctx.team.weeks.reduce((a,b) => a + b.team_total_score, 0) + (_ctx.specialReward.team_total_score || 0) : null) + " คะแนน", 1)
              ]),
              _hoisted_60
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.currentRank > 10 && _ctx.currentRank <= 70)
        ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
            _createElementVNode("div", _hoisted_62, [
              _hoisted_63,
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("div", _hoisted_65, [
                  _createElementVNode("div", _hoisted_66, "อันดับที่ " + _toDisplayString(_ctx.currentRank), 1),
                  _createElementVNode("div", _hoisted_67, "ทีม " + _toDisplayString(_ctx.team.team_name), 1)
                ]),
                _hoisted_68
              ]),
              _hoisted_69,
              _hoisted_70,
              _hoisted_71,
              _hoisted_72,
              _createElementVNode("div", _hoisted_73, [
                _hoisted_74,
                _hoisted_75,
                _createElementVNode("span", null, _toDisplayString(_ctx.team.weeks ? _ctx.team.weeks.reduce((a,b) => a + b.team_total_score, 0) + (_ctx.specialReward.team_total_score || 0) : null) + " คะแนน", 1)
              ]),
              _hoisted_76
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.currentRank > 70)
        ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
            _createElementVNode("div", _hoisted_78, [
              _hoisted_79,
              _createElementVNode("div", _hoisted_80, [
                _createElementVNode("div", _hoisted_81, [
                  _createElementVNode("div", _hoisted_82, "อันดับที่ " + _toDisplayString(_ctx.currentRank), 1),
                  _createElementVNode("div", _hoisted_83, "ทีม " + _toDisplayString(_ctx.team.team_name), 1)
                ]),
                _hoisted_84
              ]),
              _hoisted_85,
              _hoisted_86,
              _hoisted_87,
              _createElementVNode("div", _hoisted_88, [
                _hoisted_89,
                _hoisted_90,
                _createElementVNode("span", null, _toDisplayString(_ctx.team.weeks ? _ctx.team.weeks.reduce((a,b) => a + b.team_total_score, 0) + (_ctx.specialReward.team_total_score || 0) : null) + " คะแนน", 1)
              ]),
              _hoisted_91
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.team.weeks)
        ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
            _hoisted_93,
            _hoisted_94,
            _createElementVNode("div", _hoisted_95, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.team.weeks.filter(w => w.week_no <= 10), (summary, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "team-table",
                  key: i
                }, [
                  _createElementVNode("div", {
                    class: "tt-head",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleContent($event)))
                  }, [
                    _createElementVNode("div", _hoisted_96, [
                      _createElementVNode("div", _hoisted_97, [
                        _createTextVNode(" สัปดาห์ที่ " + _toDisplayString(summary.week_no) + " ", 1),
                        _createElementVNode("div", _hoisted_98, "(" + _toDisplayString(_ctx.weekTxt[summary.week_no - 1]) + ")", 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_99, [
                      _createElementVNode("div", _hoisted_100, [
                        _createElementVNode("div", _hoisted_101, _toDisplayString(summary.team_total_score) + " คะแนน", 1),
                        _hoisted_102
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_103, [
                    _createElementVNode("div", _hoisted_104, [
                      _createElementVNode("div", _hoisted_105, [
                        _createElementVNode("div", _hoisted_106, [
                          (i+1 >= 1 && i+1 <= 5 && summary.rank >= 1 && summary.rank <= 20)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_107))
                            : _createCommentVNode("", true),
                          (i+1 >= 1 && i+1 <= 5 && summary.rank >= 21 && summary.rank <= 40)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_108))
                            : _createCommentVNode("", true),
                          (i+1 >= 1 && i+1 <= 5 && summary.rank >= 41 && summary.rank <= 70)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_109))
                            : _createCommentVNode("", true),
                          (i+1 >= 6 && i+1 <= 11 && summary.rank >= 1 && summary.rank <= 20)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_110))
                            : _createCommentVNode("", true),
                          (i+1 >= 6 && i+1 <= 11 && summary.rank >= 21 && summary.rank <= 40)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_111))
                            : _createCommentVNode("", true),
                          (i+1 >= 6 && i+1 <= 11 && summary.rank >= 41 && summary.rank <= 70)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_112))
                            : _createCommentVNode("", true),
                          (i+1 >= 1 && i+1 <= 5 && summary.rank >= 1 && summary.rank <= 20)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_113, _hoisted_116))
                            : _createCommentVNode("", true),
                          (i+1 >= 1 && i+1 <= 5 && summary.rank >= 21 && summary.rank <= 40)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_117, _hoisted_120))
                            : _createCommentVNode("", true),
                          (i+1 >= 1 && i+1 <= 5 && summary.rank >= 41 && summary.rank <= 70)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_121, _hoisted_124))
                            : _createCommentVNode("", true),
                          (i+1 >= 6 && i+1 <= 11 && summary.rank >= 1 && summary.rank <= 20)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_125, _hoisted_128))
                            : _createCommentVNode("", true),
                          (i+1 >= 6 && i+1 <= 11 && summary.rank >= 21 && summary.rank <= 40)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_129, _hoisted_132))
                            : _createCommentVNode("", true),
                          (i+1 >= 6 && i+1 <= 11 && summary.rank >= 41 && summary.rank <= 70)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_133, _hoisted_136))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(summary.member_score.sort((a,b) => b.is_leader - a.is_leader), (member) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "tt-col",
                          key: member.id
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass(`team-profile ${member.is_leader ? 'lead' : ''}`)
                          }, [
                            _createElementVNode("div", _hoisted_137, [
                              _createElementVNode("div", _hoisted_138, [
                                _createElementVNode("div", _hoisted_139, [
                                  _createElementVNode("div", _hoisted_140, [
                                    _createElementVNode("div", {
                                      class: "team-image",
                                      style: _normalizeStyle({ backgroundImage: `url(${member.image ? member.image : require('@/assets/images/people.svg')})` })
                                    }, null, 4)
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_141, [
                              _createElementVNode("div", _hoisted_142, _toDisplayString(member.is_leader ? 'หัวหน้าทีม' : 'สมาชิกทีม'), 1),
                              _createElementVNode("div", _hoisted_143, [
                                _createElementVNode("div", _hoisted_144, _toDisplayString(member.name.replace(" ", "\n")), 1)
                              ])
                            ])
                          ], 2)
                        ]))
                      }), 128))
                    ]),
                    (i+1 == 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_145, [
                          _hoisted_146,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(summary.member_score.sort((a,b) => b.is_leader - a.is_leader), (member) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "tt-col",
                              key: member.id
                            }, [
                              _createElementVNode("div", {
                                class: _normalizeClass(`tt-text ${_ctx.$store.state.userInfo.party_id == member.party_id ? 'self' : ''}`)
                              }, _toDisplayString(member.score.new_member), 3)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_147, [
                      _hoisted_148,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(summary.member_score.sort((a,b) => b.is_leader - a.is_leader), (member) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "tt-col",
                          key: member.id
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass(`tt-text ${_ctx.$store.state.userInfo.party_id == member.party_id ? 'self' : ''}`)
                          }, _toDisplayString(member.score.online_class), 3)
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_149, [
                      _hoisted_150,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(summary.member_score.sort((a,b) => b.is_leader - a.is_leader), (member) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "tt-col",
                          key: member.id
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass(`tt-text ${_ctx.$store.state.userInfo.party_id == member.party_id ? 'self' : ''}`)
                          }, _toDisplayString(member.score.social_posting), 3)
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_151, [
                      _hoisted_152,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(summary.member_score.sort((a,b) => b.is_leader - a.is_leader), (member) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "tt-col",
                          key: member.id
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass(`tt-text ${_ctx.$store.state.userInfo.party_id == member.party_id ? 'self' : ''}`)
                          }, _toDisplayString(member.score.sponsoring), 3)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_153, [
                    _createElementVNode("div", _hoisted_154, [
                      (i+1 >= 1 && i+1 <= 5 && summary.rank >= 1 && summary.rank <= 20)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_155))
                        : _createCommentVNode("", true),
                      (i+1 >= 1 && i+1 <= 5 && summary.rank >= 21 && summary.rank <= 40)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_156))
                        : _createCommentVNode("", true),
                      (i+1 >= 1 && i+1 <= 5 && summary.rank >= 41 && summary.rank <= 70)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_157))
                        : _createCommentVNode("", true),
                      (i+1 >= 6 && i+1 <= 11 && summary.rank >= 1 && summary.rank <= 20)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_158))
                        : _createCommentVNode("", true),
                      (i+1 >= 6 && i+1 <= 11 && summary.rank >= 21 && summary.rank <= 40)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_159))
                        : _createCommentVNode("", true),
                      (i+1 >= 6 && i+1 <= 11 && summary.rank >= 41 && summary.rank <= 70)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_160))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_161, [
                        (i+1 >= 1 && i+1 <= 5 && summary.rank >= 1 && summary.rank <= 20)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_162, _hoisted_165))
                          : _createCommentVNode("", true),
                        (i+1 >= 1 && i+1 <= 5 && summary.rank >= 21 && summary.rank <= 40)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_166, _hoisted_169))
                          : _createCommentVNode("", true),
                        (i+1 >= 1 && i+1 <= 5 && summary.rank >= 41 && summary.rank <= 70)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_170, _hoisted_173))
                          : _createCommentVNode("", true),
                        (i+1 >= 6 && i+1 <= 11 && summary.rank >= 1 && summary.rank <= 20)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_174, _hoisted_177))
                          : _createCommentVNode("", true),
                        (i+1 >= 6 && i+1 <= 11 && summary.rank >= 21 && summary.rank <= 40)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_178, _hoisted_181))
                          : _createCommentVNode("", true),
                        (i+1 >= 6 && i+1 <= 11 && summary.rank >= 41 && summary.rank <= 70)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_182, _hoisted_185))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_186, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(summary.member_score.sort((a,b) => b.is_leader - a.is_leader), (member) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "team-detail",
                          key: member.member_id
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass(`team-profile ${member.is_leader ? 'lead' : ''}`)
                          }, [
                            _createElementVNode("div", _hoisted_187, [
                              _createElementVNode("div", _hoisted_188, [
                                _createElementVNode("div", _hoisted_189, [
                                  _createElementVNode("div", _hoisted_190, [
                                    _createElementVNode("div", {
                                      class: "team-image",
                                      style: _normalizeStyle({ backgroundImage: `url(${member.image ? member.image : require('@/assets/images/people.svg')})` })
                                    }, null, 4)
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_191, [
                              _createElementVNode("div", _hoisted_192, _toDisplayString(member.is_leader ? 'หัวหน้าทีม' : 'สมาชิกทีม'), 1),
                              _createElementVNode("div", _hoisted_193, [
                                _createElementVNode("div", null, _toDisplayString(member.name.replace(" ", "\n")), 1)
                              ])
                            ])
                          ], 2),
                          _createElementVNode("div", _hoisted_194, [
                            _createElementVNode("div", _hoisted_195, [
                              (i+1 == 1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_196, "สมาชิกที่เป็นนธอ. ใหม่"))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", {
                                class: _normalizeClass(`tt-text ${_ctx.$store.state.userInfo.party_id == member.party_id ? 'self' : ''}`)
                              }, _toDisplayString(member.score.new_member), 3)
                            ]),
                            _createElementVNode("div", _hoisted_197, [
                              _hoisted_198,
                              _createElementVNode("div", {
                                class: _normalizeClass(`tt-text ${_ctx.$store.state.userInfo.party_id == member.party_id ? 'self' : ''}`)
                              }, _toDisplayString(member.score.online_class), 3)
                            ]),
                            _createElementVNode("div", _hoisted_199, [
                              _hoisted_200,
                              _createElementVNode("div", {
                                class: _normalizeClass(`tt-text ${_ctx.$store.state.userInfo.party_id == member.party_id ? 'self' : ''}`)
                              }, _toDisplayString(member.score.social_posting), 3)
                            ]),
                            _createElementVNode("div", _hoisted_201, [
                              _hoisted_202,
                              _createElementVNode("div", {
                                class: _normalizeClass(`tt-text ${_ctx.$store.state.userInfo.party_id == member.party_id ? 'self' : ''}`)
                              }, _toDisplayString(member.score.sponsoring), 3)
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.team.weeks.filter(w => w.week_no > 10), (summary) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: summary.week_no,
                  class: "table-bonus"
                }, [
                  _hoisted_203,
                  _createElementVNode("div", _hoisted_204, [
                    _createElementVNode("div", {
                      class: "tt-head",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toggleContent($event)))
                    }, [
                      _hoisted_205,
                      _createElementVNode("div", _hoisted_206, [
                        _createElementVNode("div", _hoisted_207, [
                          _createElementVNode("div", _hoisted_208, _toDisplayString(summary.team_total_score) + " คะแนน", 1),
                          _hoisted_209
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_210, [
                      _createElementVNode("div", _hoisted_211, [
                        _hoisted_212,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(summary.member_score, (member) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: member.member_id,
                            class: "tt-col"
                          }, [
                            _createElementVNode("div", {
                              class: _normalizeClass(`team-profile ${member.is_leader ? 'lead': ''}`)
                            }, [
                              _createElementVNode("div", _hoisted_213, [
                                _createElementVNode("div", _hoisted_214, [
                                  _createElementVNode("div", _hoisted_215, [
                                    _createElementVNode("div", _hoisted_216, [
                                      _createElementVNode("div", {
                                        class: "team-image",
                                        style: _normalizeStyle({ backgroundImage: `url(${member.image ? member.image : require('@/assets/images/people.svg')})` })
                                      }, null, 4)
                                    ])
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_217, [
                                _createElementVNode("div", _hoisted_218, _toDisplayString(member.is_leader ? 'หัวหน้าทีม': 'สมาชิกทีม'), 1),
                                _createElementVNode("div", _hoisted_219, [
                                  _createElementVNode("div", _hoisted_220, _toDisplayString(member.name.replace(" ", "\n")), 1)
                                ])
                              ])
                            ], 2)
                          ]))
                        }), 128))
                      ]),
                      _createElementVNode("div", _hoisted_221, [
                        _hoisted_222,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(summary.member_score, (member) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "tt-col",
                            key: member.id
                          }, [
                            _createElementVNode("div", {
                              class: _normalizeClass(`tt-text ${_ctx.$store.state.userInfo.party_id == member.party_id ? 'self' : ''}`)
                            }, _toDisplayString(member.score.social_join), 3)
                          ]))
                        }), 128))
                      ]),
                      _createElementVNode("div", _hoisted_223, [
                        _hoisted_224,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(summary.member_score, (member) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "tt-col",
                            key: member.id
                          }, [
                            _createElementVNode("div", {
                              class: _normalizeClass(`tt-text ${_ctx.$store.state.userInfo.party_id == member.party_id ? 'self' : ''}`)
                            }, _toDisplayString(member.score.body_key), 3)
                          ]))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_225, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.team.weeks.filter(w => w.week_no > 10), (summary) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "team-detail-area",
                          key: summary.week_no
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(summary.member_score.sort((a,b) => b.is_leader - a.is_leader), (member) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "team-detail",
                              key: member.member_id
                            }, [
                              _createElementVNode("div", {
                                class: _normalizeClass(`team-profile ${member.is_leader ? 'lead' : ''}`)
                              }, [
                                _createElementVNode("div", _hoisted_226, [
                                  _createElementVNode("div", _hoisted_227, [
                                    _createElementVNode("div", _hoisted_228, [
                                      _createElementVNode("div", _hoisted_229, [
                                        _createElementVNode("div", {
                                          class: "team-image",
                                          style: _normalizeStyle({ backgroundImage: `url(${member.image ? member.image : require('@/assets/images/people.svg')})` })
                                        }, null, 4)
                                      ])
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_230, [
                                  _createElementVNode("div", _hoisted_231, _toDisplayString(member.is_leader ? 'หัวหน้าทีม': 'สมาชิกทีม'), 1),
                                  _createElementVNode("div", _hoisted_232, [
                                    _createElementVNode("div", _hoisted_233, _toDisplayString(member.name.replace(" ", "\n")), 1)
                                  ])
                                ])
                              ], 2),
                              _createElementVNode("div", _hoisted_234, [
                                _createElementVNode("div", _hoisted_235, [
                                  _hoisted_236,
                                  _createElementVNode("div", _hoisted_237, _toDisplayString(member.score.social_join), 1)
                                ]),
                                _createElementVNode("div", _hoisted_238, [
                                  _hoisted_239,
                                  _createElementVNode("div", _hoisted_240, _toDisplayString(member.score.body_key), 1)
                                ])
                              ])
                            ]))
                          }), 128))
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_241
  ]))
}